<template>
  <div id="app">
    <component v-if="errorComp" :is="errorComp" />
    <router-view v-else></router-view>
    <Loading />
    <ServerInfo />
    <PopupManager />
  </div>
</template>

<script>
import PopupManager from './views/PopupManager'
import { mapState } from 'vuex'

export default {
  watch: {
    errorComp(val) {
      if (val) this.$EventBus.$emit('onErrorPage')
    }
  },
  computed: {
    ...mapState(['errorState']),
    errorComp() {
      if (!this.errorState) return null
      switch (this.errorState) {
        case 'unauthenticated': return 'Unauthenticated'
        case 'loginFail': return 'LoginFail'
        default : return 'Error'
      }
    }
  },
  components: {
    PopupManager,
    Unauthenticated: () => import('./views/Errors/Unauthenticated'),
    Error: () => import('./views/Errors/NotFoundPage'),
    LoginFail: () => import('./views/Errors/LoginFail'),
  },
}
</script>

<style lang="scss">

</style>